import React from 'react';

/**
 * Renders the desktop version of the Account navigation
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const AccountDesktopNavigation = ({
  customer,
  activeSection,
  supportEmail,
  account_support_label,
  account_support_phone,
  account_support_email,
}) => (
  <div className="c-account-desktop-navigation">
    <h4 className="c-account-desktop-navigation__heading h2-roobert">
      Welcome{customer.firstName ? `, ${customer.firstName}` : ''}
    </h4>
    <ul className="c-account-desktop-navigation__list body-2">
      <li className="c-account-desktop-navigation__item text-cta cta">
        <a className="color-black" href={'/account'}>
          My Account
        </a>
      </li>
      <li className="c-account-desktop-navigation__item is-active text-cta cta">
        <a className="color-black" href={'/account#history'}>
          Order History
        </a>
      </li>
      <li className="c-account-desktop-navigation__item text-cta cta">
        <a href="/account/logout">Log Out</a>
      </li>
    </ul>
    <div className=" c-account-desktop-navigation__contact">
      <p className="ty-body2">{account_support_label}</p>
      <a className="ty-body2" href={`tel:${account_support_phone}`}>
        {account_support_phone}
      </a>
      <br />
      <a className="ty-body2" href={`mailto:${account_support_email}`}>
        {account_support_email}
      </a>
    </div>
  </div>
);

export default AccountDesktopNavigation;
